import { resolveListCheckInState } from "../utils/shiftListStatusDisplay";

const EMPTY_POSITION_COUNTS = () => ({
  future: 0,
  late: 0,
  in: 0,
  out: 0,
  no_show: 0,
});

function shiftRowForStatus(shift) {
  return {
    checkInState: shift.checkInState,
    checkin_date: shift.checkin_date,
    checkout_date: shift.checkout_date,
    checkin_unpaid_break_minutes: shift.checkin_unpaid_break_minutes,
    signoff_state: shift.signoff_state,
    actual_state: shift.actual_state,
    start_date: shift.start_date,
    end_date: shift.end_date,
    unpaid_break: shift.unpaid_break,
    checkin_signoff_date: shift.checkin_signoff_date,
  };
}

function hasCheckoutDate(shift) {
  return !!(shift?.checkout_date && String(shift.checkout_date).trim());
}

/** Legacy contact dashboard columns: Future, Late, In, Out, No Show. */
export function getDashboardStatKey(shift) {
  const chipState = resolveListCheckInState(shiftRowForStatus(shift));
  const hasCheckout = hasCheckoutDate(shift);

  if (chipState === "noshow") return "no_show";
  if (chipState === "future") return "future";
  if (chipState === "late") return "late";
  if (chipState === "checkIn") return "in";
  if (
    hasCheckout &&
    (chipState === "signoffPending" ||
      chipState === "signoffPendingReview" ||
      chipState === "signoffComplete")
  ) {
    return "out";
  }
  if (chipState === "signoffPending" || chipState === "signoffPendingReview") {
    return "in";
  }
  if (chipState === "signoffComplete") return "out";
  return null;
}

/**
 * Group confirmed shifts into legacy schedule-position-stats shape:
 * one block per client location, rows per position with status counts.
 */
export function buildPositionStatsByLocation(shifts = []) {
  const locationMap = new Map();

  for (const shift of shifts || []) {
    const locKey = `${shift.client_id ?? ""}-${shift.client_location_id ?? ""}`;
    if (!locationMap.has(locKey)) {
      locationMap.set(locKey, {
        clientId: shift.client_id,
        clientName: shift.client_name || "Client",
        clientLocationId: shift.client_location_id,
        locationName: shift.location_name || "Primary Location",
        positions: new Map(),
      });
    }

    const location = locationMap.get(locKey);
    const posKey = String(shift.position_id ?? shift.position_name ?? "unknown");
    if (!location.positions.has(posKey)) {
      location.positions.set(posKey, {
        positionId: shift.position_id,
        positionName: shift.position_name || "General Position",
        ...EMPTY_POSITION_COUNTS(),
      });
    }

    const position = location.positions.get(posKey);
    const statKey = getDashboardStatKey(shift);
    if (statKey && position[statKey] != null) {
      position[statKey] += 1;
    }
  }

  return Array.from(locationMap.values())
    .map((location) => ({
      ...location,
      positions: Array.from(location.positions.values()).sort((a, b) =>
        String(a.positionName).localeCompare(String(b.positionName)),
      ),
    }))
    .sort((a, b) =>
      String(a.locationName).localeCompare(String(b.locationName)),
    );
}
